// extracted by mini-css-extract-plugin
export default {"list":"SessionStats_list__tO4+j","item":"SessionStats_item__ssBxZ","players":"SessionStats_players__nsdJL","separator":"SessionStats_separator__QMkL3"};